"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchStoredLoader = exports.StoredLawXML = void 0;
const common_1 = require("./common");
const data_paths = __importStar(require("../paths"));
const path_1 = __importDefault(require("path"));
const node_fetch_1 = require("../../util/node-fetch");
const fetch = (global["fetch"]) || (global["window"] && window.fetch) || node_fetch_1.fetch;
console.log(`fetch: ${fetch}`);
const fetchText = async (textPath) => {
    try {
        const res = await fetch(textPath);
        if (!res.ok) {
            console.log(res.statusText);
            return null;
        }
        return await res.text();
    }
    catch (e) {
        console.log(e);
        return null;
    }
};
const fetchSjisText = async (textPath) => {
    try {
        const res = await fetch(textPath);
        if (!res.ok) {
            console.log(res.statusText);
            return null;
        }
        const buf = await res.arrayBuffer();
        const decoder = new TextDecoder("shift-jis");
        return decoder.decode(buf);
    }
    catch (e) {
        console.log(e);
        return null;
    }
};
class StoredLawXML extends common_1.LawXMLStruct {
    lawdataPath;
    lawInfo;
    _xml;
    constructor(lawdataPath, lawInfo, _xml) {
        super();
        this.lawdataPath = lawdataPath;
        this.lawInfo = lawInfo;
        this._xml = _xml;
    }
    get xml() {
        return this._xml;
    }
    async getPictFileOrBlobURL(src) {
        const url = path_1.default.join(this.lawdataPath, this.lawInfo.Path, src);
        const res = await fetch(url, { method: "HEAD" });
        if (!res.ok)
            return null;
        return { url, type: res.headers.get("Content-Type") ?? "" };
    }
    async getPictBlob(src) {
        const url = path_1.default.join(this.lawdataPath, this.lawInfo.Path, src);
        const res = await fetch(url);
        if (!res.ok)
            return null;
        const blob = await res.blob();
        return { buf: await blob.arrayBuffer(), type: res.headers.get("Content-Type") ?? "" };
    }
}
exports.StoredLawXML = StoredLawXML;
class FetchStoredLoader extends common_1.Loader {
    dataPath;
    constructor(dataPath) {
        super();
        this.dataPath = dataPath;
    }
    get listJsonPath() { return data_paths.getListJsonPath(this.dataPath); }
    get listCSVPath() { return data_paths.getListCSVPath(this.dataPath); }
    get lawdataPath() { return data_paths.getLawdataPath(this.dataPath); }
    async loadLawInfosStruct() {
        const text = await fetchText(this.listJsonPath);
        if (text === null)
            throw new Error("Text cannot be fetched");
        return (0, common_1.jsonTextToLawInfos)(text);
    }
    async loadBaseLawInfosFromCSV() {
        let text = null;
        text = await fetchSjisText(this.listCSVPath);
        if (!(text?.includes("法令番号"))) {
            text = await fetchText(this.listCSVPath);
            if (text?.charCodeAt(0) === 0xFEFF) {
                text = text.substring(1);
            }
        }
        if (text === null)
            throw new Error("Text cannot be fetched");
        return (0, common_1.csvTextToLawInfos)(text);
    }
    async loadLawXMLStructByInfo(lawInfo) {
        const filepath = path_1.default.join(this.lawdataPath, lawInfo.Path, lawInfo.XmlName);
        const text = await fetchText(filepath);
        if (text === null)
            throw new Error("Text cannot be fetched");
        return new StoredLawXML(this.lawdataPath, lawInfo, text);
    }
    async listCSVExists() {
        try {
            const res = await fetch(this.listCSVPath, { method: "HEAD" });
            return res.ok;
        }
        catch (e) {
            return false;
        }
    }
    async listJsonExists() {
        try {
            const res = await fetch(this.listJsonPath, { method: "HEAD" });
            return res.ok;
        }
        catch (e) {
            return false;
        }
    }
}
exports.FetchStoredLoader = FetchStoredLoader;
exports.default = FetchStoredLoader;
//# sourceMappingURL=FetchStoredLoader.js.map